import { Link } from "react-router-dom";
import { categories } from "../../mocks/categories";

type Work = {
  id: string;
  title: string;
  author: string;
  categoryId: string;
  status: string;
  chapters: number;
  words: string;
  rating: number;
  views: string;
  favorites: string;
  updated: string;
  cover: string;
  tags: string[];
  summary: string;
  intro: string;
};

export function getCategoryName(categoryId: string) {
  return categories.find((c) => c.id === categoryId)?.name ?? "未分类";
}

export default function WorkCard({ work }: { work: Work }) {
  return (
    <Link
      to={`/work/${work.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-300/60 bg-background-100 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/40"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={work.cover}
          alt={`${work.title} 同人作品封面`}
          title={`${work.title} 火影忍者同人作品`}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-background-50/80 px-2.5 py-1 text-xs font-medium text-foreground-800 backdrop-blur-sm">
          {work.status}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-md bg-primary-500/90 px-2 py-1 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-[10px]" />
          {work.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center justify-between gap-2">
          <span className="rounded px-2 py-0.5 text-[11px] text-primary-300 bg-primary-500/10">
            {getCategoryName(work.categoryId)}
          </span>
          <span className="text-xs text-foreground-400">{work.updated}</span>
        </div>
        <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-300">
          {work.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-400">@{work.author}</p>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-300">
          {work.summary}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {work.tags.slice(0, 3).map((t) => (
            <span key={t} className="rounded-md bg-background-200/70 px-2 py-0.5 text-[11px] text-foreground-400">
              #{t}
            </span>
          ))}
        </div>
        <div className="mt-4 flex items-center justify-between border-t border-background-300/60 pt-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-book-open-line" />
            {work.chapters} 章
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {work.views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-heart-line" />
            {work.favorites}
          </span>
        </div>
      </div>
    </Link>
  );
}